import { CircularProgress } from '@mui/material';
import React from 'react';
import Wrapper from './styles/Wrapper';

function Loading() {
  return (
    <Wrapper>
      <CircularProgress />
    </Wrapper>
  );
}

export default Loading;
